import { Heart } from 'lucide-react';
import { SUPPORT_URL } from '../lib/config';
import { useI18n } from '../i18n/I18nContext';

export const SupportButton = ({ variant = 'button', testid = 'support-project-btn' }) => {
  const { t } = useI18n();
  if (variant === 'link') {
    return (
      <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" data-testid={testid}
        className="hover:text-or-300 inline-flex items-center gap-1.5">
        <Heart className="w-3.5 h-3.5 text-or-400" strokeWidth={2.5} /> {t('common.support')}
      </a>
    );
  }
  return (
    <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" data-testid={testid}
      className="inline-flex items-center gap-2 rounded-full border-2 border-or-400/60 text-or-300 font-bold px-6 py-3 hover:bg-or-400/10 hover:-translate-y-0.5 transition-all">
      <Heart className="w-5 h-5" strokeWidth={2.5} /> {t('landing.supportCta')}
    </a>
  );
};
